import { LinkDataField } from "./LinkDataField";
import { LinkProtocol } from "./LinkProtocol";

export class StringDataField extends LinkDataField {
	public static readonly $type: string = "StringDataField";
	public readonly $type: string = StringDataField.$type;
}
